import { useCallback, useState } from "react";
import { RequestSettings } from "./types";
import UseAuthConfig from "./useAuthConfig";
import { debounce } from "lodash";

interface UseRequestLeadsOptions {
  pageSize?: number;
  pageNumber?: number;
  searchText?: string;
  name?: string;
  performanceType?: string;
  sortOrder?: number;
  orderBy?: string;
  parameterOne?: string;
  parameterTwo?: string;
  parameterThree?: string;
}

const useRequestLeads = (
  options: UseRequestLeadsOptions = {}
): [RequestSettings, (settings: Partial<RequestSettings>) => void] => {
  const { protectedResources }: any = UseAuthConfig();

  const [reqRequests, setReqRequest] = useState<RequestSettings>({
    PageNumber: options.pageNumber ?? 1,
    SearchText: options.searchText ?? "",
    Name: options.name ?? "",
    PerformanceType: options.performanceType ?? "",
    SortOrder: options.sortOrder ?? 1,
    PageSize: options.pageSize ?? 10,
    OrderBy: options.orderBy ?? "",
    ParameterOne: options.parameterOne ?? "Requested,Rejected",
    ParameterTwo: options.parameterTwo ?? "",
    ParameterThree: options.parameterThree ?? "Requested,Rejected",
    url: protectedResources.apiTodoList.endpoint,
    accessToken: localStorage.getItem("AccessToken"),
  });

  const updateSettings = useCallback(
    debounce((settings: Partial<RequestSettings>) => {
      setReqRequest((prevSettings) => ({ ...prevSettings, ...settings }));
    }, 300),
    []
  );

  return [reqRequests, updateSettings];
};

export default useRequestLeads;
